<template>
  <div>
    <PageAllow
      controller="MaterialShowCategories"
      action="add"
      :prohibit="
        settings &&
        settings.miniprogram &&
        settings.miniprogram.template_id != '4' &&
        settings.miniprogram.template_id != '3'
      "
    />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <v-text-field
              v-model="materialShowCategoriesSearch"
              :label="$t('MaterialShowCategory.showCategoryKeyword')"
              flat
              clearable
            ></v-text-field>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="getMaterialShowCategoriesFromAPI()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="materialShowCategoriesSearch = ''"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-spacer />
            <v-btn
              v-if="
                $permission.permissionAllow('MaterialShowCategories', 'add')
              "
              small
              color="primary"
              @click.stop="
                currentItem = { id: 0 };
                editDialog = true;
              "
              class="mt-6"
            >
              <v-icon x-small class="pe-1">fa-plus</v-icon>
              {{ $t("CRUD.newInfo", [$t("MaterialShowCategory.ObjectName")]) }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card class="mx-4 mb-4">
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-btn text x-large color="primary" @click.stop="openAll = !openAll">
          {{ $t("openAll") }} / {{ $t("closeAll") }}
        </v-btn>
        <v-divider />
        <v-treeview
          class="py-2"
          v-model="tree"
          :items="materialShowCategories"
          :search="materialShowCategoriesSearch"
          :filter="showCategoriesFilter"
          item-key="code"
          item-children="show_categories"
          hoverable
          activatable
          return-object
          :open.sync="showCategoriesOpen"
        >
          <template v-slot:label="{ item }">
            <v-chip> {{ item.number }} </v-chip>
            {{ item.name }}

            <v-icon
              small
              v-if="
                $permission.permissionAllow('MaterialShowCategories', 'edit')
              "
              color="primary"
              class="px-1 py-4 me-1"
              @click.stop="
                currentItem = JSON.parse(JSON.stringify(item));
                editDialog = true;
              "
              >fa-pencil-alt
            </v-icon>
            <v-icon
              small
              v-if="
                !item.parent_id &&
                $permission.permissionAllow('MaterialShowCategories', 'add')
              "
              color="primary"
              class="px-1 py-4 me-1"
              @click.stop="
                currentItem = {
                  parent_id: item.id,
                  parent_number: item.number,
                  parent_name: item.name,
                };
                editDialog = true;
              "
              >fa-plus
            </v-icon>
            <v-icon
              small
              v-if="
                item.deletable &&
                $permission.permissionAllow('MaterialShowCategories', 'delete')
              "
              color="accent"
              class="px-1 py-4 me-1"
              @click.stop="
                currentItem = JSON.parse(JSON.stringify(item));
                deleteDialog = true;
              "
              >fa-trash-alt
            </v-icon>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  color="secondary"
                  class="px-1 py-4 me-1"
                  @click.stop="
                    $router.push('/materials?show_category_id=' + item.id)
                  "
                  >fa-external-link-alt
                </v-icon>
              </template>
              <span>{{
                $t("MaterialShowCategory.externalLinkToMaterials")
              }}</span>
            </v-tooltip>
          </template>
        </v-treeview>
      </v-card>
    </v-sheet>

    <v-dialog persistent v-model="editDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{
            $t("MaterialShowCategory.ObjectNameInfo")
          }}</span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="editDialog = false"
                >fa-times
              </v-icon>
            </template>
            <span>
              {{
                $t("CRUD.backToList", [$t("MaterialShowCategory.ObjectName")])
              }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-container>
            <ValidationObserver ref="observer">
              <v-form>
                <v-row>
                  <v-col
                    cols="12"
                    v-if="currentItem.parent_id && !currentItem.id"
                  >
                    <v-text-field
                      required
                      readonly
                      :label="
                        $t('MaterialShowCategory.Fields.parent_number_and_name')
                      "
                      :value="
                        currentItem.parent_number +
                        ' / ' +
                        currentItem.parent_name
                      "
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="
                        $t('MaterialShowCategory.Fields.show_category_number')
                      "
                      rules="required"
                    >
                      <v-text-field
                        required
                        v-model="currentItem.number"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'number')
                            .concat(errors)
                        "
                      >
                        <template v-slot:label>
                          {{
                            $t(
                              "MaterialShowCategory.Fields.show_category_number"
                            )
                          }}
                          <span class="red--text">*</span>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="
                        $t('MaterialShowCategory.Fields.show_category_name')
                      "
                      rules="required"
                    >
                      <v-text-field
                        required
                        v-model="currentItem.name"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'name')
                            .concat(errors)
                        "
                      >
                        <template v-slot:label>
                          {{
                            $t("MaterialShowCategory.Fields.show_category_name")
                          }}
                          <span class="red--text">*</span>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field required v-model="currentItem.sort">
                      <template v-slot:label>
                        {{
                          $t("MaterialShowCategory.Fields.show_category_sort")
                        }}
                      </template>
                    </v-text-field>
                  </v-col>
                  <!-- 添加icon图片 -->
                  <v-col cols="12">
                    <v-card v-if="img" max-width="240">
                      <v-img
                        :src="img"
                        @click.stop="$showFullscreenImages([img])"
                      >
                        <v-tooltip right v-if="img">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              color="secondary"
                              class="pa-2 float-right"
                              @click.stop="
                                !img.startsWith('data:image/') &&
                                img == currentItem.icon_url
                                  ? (currentItem.icon_url = img = null)
                                  : (img = null)
                              "
                            >
                              fa-times
                            </v-icon>
                          </template>
                          <span> {{ $t("Material.delImg") }}</span>
                        </v-tooltip>
                      </v-img>
                    </v-card>
                    <v-file-input
                      ref="img_file"
                      show-size
                      prepend-icon="fa-camera"
                      accept="image/png, image/jpeg"
                      persistent-hint
                      :placeholder="$t('MaterialShowCategory.imgPlaceholder')"
                      :hint="
                        $t('BusinessSetting.AppAndWxApp.imgHint', [400, 400])
                      "
                      :rules="imgRules"
                      v-model="img_file"
                    >
                    </v-file-input>
                  </v-col>
                </v-row>
              </v-form>
            </ValidationObserver>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="editDialog = false">{{
            $t("$vuetify.close")
          }}</v-btn>
          <v-btn color="accent" @click="save()">{{ $t("CRUD.save") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DialogDelete
      v-model="deleteDialog"
      :label="$t('MaterialShowCategory.ObjectName')"
      @confirm="
        del();
        deleteDialog = false;
      "
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import MaterialShowCategories from "@/api/material_show_categories";
import DialogDelete from "@/components/plugins/DialogDelete";
import Files from "@/api/files";

setInteractionMode("eager");

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    ValidationProvider,
    ValidationObserver,
    DialogDelete,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.materialManagement"),
        disabled: false,
        href: "/materials",
      },
      {
        text: i18n.t("Nav.materialShowCategories"),
        disabled: true,
        href: "/material-show-categories",
      },
    ],

    showCategoriesFilter() {
      return (item, search) =>
        item.name.indexOf(search) > -1 || item.number.indexOf(search) > -1;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  mounted() {
    this.getMaterialShowCategoriesFromAPI();
  },

  data: () => ({
    menu: false,
    editDialog: false,
    snackbar: false,
    snackbarMsg: "",
    deleteDialog: false,
    tree: [],
    materialShowCategories: [],
    materialShowCategoriesSearch: "",
    materialShowCategoriesSelected: [],
    currentItem: {},
    serverErrors: [],
    openAll: false,
    showCategoriesOpen: [],
    img: "",
    img_file: null,
    imgRules: [
      (value) => !value || value.size < 5000000 || i18n.t("Material.imgHint"),
    ],
  }),

  methods: {
    openTree(openArr) {
      for (var i = 0; i < openArr.length; i++) {
        this.showCategoriesOpen.push(openArr[i]);
        if (openArr[i].show_categories.length > 0) {
          this.openTree(openArr[i].show_categories);
        }
      }
    },
    getMaterialShowCategoriesFromAPI() {
      MaterialShowCategories.tree().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.materialShowCategories = response.data.show_categories;
          }
        }.bind(this)
      );
    },
    save() {
      this.serverErrors = [];
      this.$store.dispatch("fullscreenLoading");
      if (this.$refs.img_file.hasError) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }
      this.$refs.observer.validate().then(
        async function (result) {
          if (result) {
            if (this.img_file) {
              let response = await Files.imageUpload(
                this.img_file,
                true,
                "show_category"
              );
              if (response.data.status.isOK()) {
                this.currentItem.icon_url = response.data.data.img_name;
                this.currentItem.thumbnail = response.data.data.thumbnail;
              }
            }
            // console.log(this.currentItem.icon_url);
            MaterialShowCategories.save(this.currentItem.id, this.currentItem)
              .then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.$emit("save", this.currentItem);
                    this.getMaterialShowCategoriesFromAPI();
                    this.editDialog = false;
                    this.$store.dispatch("fullscreenLoadingStop");
                  } else if (
                    response.data.error &&
                    response.data.error.data &&
                    "ERR333" == response.data.error.code
                  ) {
                    this.serverErrors = response.data.error.data;
                  }
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              )
              .catch(
                function () {
                  this.editDialog = false;
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    del() {
      MaterialShowCategories.del(this.currentItem.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getMaterialShowCategoriesFromAPI();
          }
        }.bind(this)
      );
    },
  },

  watch: {
    currentItem: {
      handler() {
        if (this.currentItem.icon_url) {
          this.img = this.currentItem.icon_url;
        } else {
          this.img = "";
        }
        this.img_file = null;
      },
    },
    img: {
      handler() {
        if (!this.img) {
          this.img_file = null;
        }
      },
    },
    img_file: {
      handler() {
        if (this.img_file) {
          var reader = new FileReader();
          reader.readAsDataURL(this.img_file);
          let that = this;
          reader.onload = function () {
            that.img = this.result;
          };
        } else {
          this.img = this.currentItem.icon_url;
        }
        // console.log(this.img);
      },
    },
    editDialog: {
      handler() {
        if (!this.editDialog) {
          this.$refs.observer.reset();
          this.serverErrors = [];
          this.$store.dispatch("fullscreenLoadingStop");
        }
      },
    },
    openAll: {
      handler() {
        if (this.openAll) {
          this.openTree(this.materialShowCategories);
        } else {
          this.showCategoriesOpen = [];
        }
      },
    },
  },
};
</script>